module.exports = __webpack_public_path__ + "static/media/ursula.e80a0bd2.jpg";